import { put, select, takeLatest } from 'redux-saga/effects'
import { getOperationsSelector } from '../selectors'
import { OperationsConstants } from '../store/operations.constants'
import { IOperationsState } from '../store/operations.types'
import { getOperationsOptionsSelector } from '../../../options/selectors/operationsOptions.selector'
import { setJointCommissionTimeOutArray as setJointCommissionTimeOutArrayAction } from '../store/operations.actions'
import { IOptions } from '../../../../common/common.types'
import { IOperationsOptionsState } from '../../../options/store/options.types'

export function* setJointCommissionTimeOutArray() {
  const operationsState: IOperationsState = yield select(getOperationsSelector)
  const { rightPatient, rightProcedure, rightConsent, rightSiteSide, rightPosition, complete } = operationsState
  const operationsOptions: IOperationsOptionsState = yield select(getOperationsOptionsSelector)
  const { jointCommissionTimeOutOptions } = operationsOptions
  const jcTimeOutArray: IOptions = []

  if (rightPatient) {
    const rightPatientOption = jointCommissionTimeOutOptions.filter((option) => option.name === 'Right Patient')
    if (rightPatientOption.length > 0) jcTimeOutArray.push(rightPatientOption[0])
  }
  if (rightProcedure) {
    const rightProcedureOption = jointCommissionTimeOutOptions.filter((option) => option.name === 'Right Procedure')
    if (rightProcedureOption.length > 0) jcTimeOutArray.push(rightProcedureOption[0])
  }
  if (rightConsent) {
    const rightConsentOption = jointCommissionTimeOutOptions.filter((option) => option.name === 'Right Consent')
    if (rightConsentOption.length > 0) jcTimeOutArray.push(rightConsentOption[0])
  }
  if (rightSiteSide) {
    const rightSiteOption = jointCommissionTimeOutOptions.filter((option) => option.name === 'Right Site/Side')
    if (rightSiteOption.length > 0) jcTimeOutArray.push(rightSiteOption[0])
  }
  if (rightPosition) {
    const rightPositionOption = jointCommissionTimeOutOptions.filter((option) => option.name === 'Right Position')
    if (rightPositionOption.length > 0) jcTimeOutArray.push(rightPositionOption[0])
  }
  if (complete) {
    const completeOption = jointCommissionTimeOutOptions.filter((option) => option.name === 'Complete')
    if (completeOption.length > 0) jcTimeOutArray.push(completeOption[0])
  }
  yield put(setJointCommissionTimeOutArrayAction(jcTimeOutArray))
}

export function* setJointCommissionTimeOutArraySaga() {
  yield takeLatest(
    [
      OperationsConstants.SET_RIGHT_PATIENT,
      OperationsConstants.SET_RIGHT_POSITION,
      OperationsConstants.SET_RIGHT_CONSENT,
      OperationsConstants.SET_RIGHT_SITE_SIDE,
      OperationsConstants.SET_RIGHT_PROCEDURE,
      OperationsConstants.SET_COMPLETE,
    ],
    setJointCommissionTimeOutArray
  )
}
